var exports = {
  "Aw": "Overview__7ktPgL",
  "fh": "Cell__mpQZOo",
  "VY": "Description__RfNV20",
  "B8": "List__UZHmpg",
  "ck": "ListItem__aGtgzn",
};

module.exports = exports;
